module.exports = __webpack_public_path__ + "static/media/MyCheckScreen.057d9509.png";